/* esm.sh - three-mesh-bvh@0.9.10/src/math/ExtendedTriangle */
export * from "/*three-mesh-bvh@0.9.10/esnext/src/math/ExtendedTriangle.mjs";
